import Link from 'next/link'
import { Image } from '@dustin-web/microsite-components/src/image/image'

export type CategoryThumbnailProps = {
  imgSrc: string
  href: string
  name?: string
  englishCategoryName?: string | null
  itemOnClick?: (selection: string) => void
}

const CategoryThumbnail = ({
  imgSrc,
  href,
  name,
  itemOnClick,
  englishCategoryName,
}: CategoryThumbnailProps) => {
  return (
    <div className="u-pt-8 u-pb-8 u-h-100 d-flex">
      <Link
        onClick={() => itemOnClick && englishCategoryName && itemOnClick(englishCategoryName)}
        className="d-flex u-bg-white u-w-100 align-items-sm-center u-decoration-none u-px-12 u-py-12 u-px-sm-24 u-py-sm-16 u-border u-border-light u-radius-4 flex-column flex-sm-row"
        prefetch={false}
        href={href}
        scroll={true}>
        <Image
          src={imgSrc}
          alt={name || ''}
          width={54}
          height={41}
          className="u-mr-12 u-mb-12 u-mb-sm-0"
        />
        {name ? <h2 className="u-fs-14 u-mb-0">{name}</h2> : null}
      </Link>
    </div>
  )
}

export default CategoryThumbnail
